export const MODEL_TYPE_OBJECT = 'MODEL_TYPE_OBJECT';
export const MODEL_TYPE_NESTED_LIST = 'MODEL_TYPE_NESTED_LIST';
export const MODEL_TYPE_LIST = 'MODEL_TYPE_LIST';
export const MODEL_TYPE_DATE = 'MODEL_TYPE_DATE';

const user = { resource: 'users', type: MODEL_TYPE_OBJECT };
const role = { resource: 'roles', type: MODEL_TYPE_OBJECT };

export const userRoleDescriptor = {
    user,
    role,
}